import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Injectable, StaticProvider, signal } from '@angular/core';

export type ModalConfig = {
  componentProps?: Record<string, any>;
  hasBackdrop?: boolean;
  disableClose?: boolean;
  providers?: StaticProvider[];
};

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  modals = signal<DialogRef<any, ComponentType<any>>[]>([]);

  constructor(private readonly dialog: Dialog) {}

  public create<T = any>(
    component: ComponentType<any>,
    config?: ModalConfig,
  ): DialogRef<T, ComponentType<any>> {
    const dialogRef = this.dialog.open<T, unknown, ComponentType<any>>(
      component,
      {
        data: config?.componentProps,
        hasBackdrop: config?.hasBackdrop ?? true,
        disableClose: config?.disableClose ?? true,
        providers: config?.providers,
      },
    );

    this.modals.update((modals) => [...modals, dialogRef]);

    dialogRef.closed.subscribe({
      next: (data) => {
        this.modals.update((modals) =>
          modals.filter((modal) => modal !== dialogRef),
        );
      },
    });

    return dialogRef;
  }

  close(modal?: DialogRef<any, any>, result?: any) {
    const modalToClose = modal ?? this.modals()[this.modals().length - 1];
    if (modalToClose) {
      modalToClose.close(result);
      this.modals.update((modals) => modals.filter((m) => m !== modalToClose));
    }
  }

  closeAll(result?: any) {
    this.modals().forEach((modal) => modal.close(result));
    this.modals.set([]);
  }
}
